export const salesData = [
  {
    invoice_id: "5602213870380292",
    date: "2022-06-02",
    sales: 558,
  },
  {
    invoice_id: "3581521800776789",
    date: "2022-06-02",
    sales: 562,
  },
  {
    invoice_id: "6380593731474293",
    date: "2022-06-10",
    sales: 561,
  },
  {
    invoice_id: "5010127616589519",
    date: "2022-06-10",
    sales: 622,
  },
  {
    invoice_id: "5100174240181124",
    date: "2022-06-09",
    sales: 177,
  },
  {
    invoice_id: "3573912377552044",
    date: "2022-06-02",
    sales: 954,
  },
  {
    invoice_id: "372301478763545",
    date: "2022-06-05",
    sales: 289,
  },
  {
    invoice_id: "6331107102159233",
    date: "2022-06-11",
    sales: 901,
  },
  {
    invoice_id: "4026044936337997",
    date: "2022-06-07",
    sales: 761,
  },
  {
    invoice_id: "30459383119833",
    date: "2022-06-05",
    sales: 972,
  },
  {
    invoice_id: "3575003264838205",
    date: "2022-06-13",
    sales: 107,
  },
  {
    invoice_id: "201991337700345",
    date: "2022-06-07",
    sales: 402,
  },
  {
    invoice_id: "5291210319996999",
    date: "2022-06-11",
    sales: 98,
  },
  {
    invoice_id: "3544332379261294",
    date: "2022-06-10",
    sales: 653,
  },
  {
    invoice_id: "490367652809482092",
    date: "2022-06-13",
    sales: 552,
  },
  {
    invoice_id: "5602236269789963",
    date: "2022-06-06",
    sales: 603,
  },
  {
    invoice_id: "3532921490095492",
    date: "2022-06-03",
    sales: 861,
  },
  {
    invoice_id: "5602241934161986",
    date: "2022-06-13",
    sales: 81,
  },
  {
    invoice_id: "3580673474393812",
    date: "2022-06-12",
    sales: 249,
  },
  {
    invoice_id: "5602218962303625476",
    date: "2022-06-02",
    sales: 262,
  },
  {
    invoice_id: "3581662440337580",
    date: "2022-06-14",
    sales: 977,
  },
  {
    invoice_id: "3579331675761690",
    date: "2022-06-11",
    sales: 742,
  },
  {
    invoice_id: "670641491389768678",
    date: "2022-06-11",
    sales: 866,
  },
  {
    invoice_id: "3560663932659205",
    date: "2022-06-11",
    sales: 346,
  },
  {
    invoice_id: "3585943580070850",
    date: "2022-06-12",
    sales: 171,
  },
  {
    invoice_id: "5108752635212810",
    date: "2022-06-02",
    sales: 875,
  },
  {
    invoice_id: "3546375894799593",
    date: "2022-06-11",
    sales: 429,
  },
  {
    invoice_id: "3573026263505188",
    date: "2022-06-14",
    sales: 793,
  },
  {
    invoice_id: "3556852285949943",
    date: "2022-06-08",
    sales: 134,
  },
  {
    invoice_id: "3575734822555838",
    date: "2022-06-08",
    sales: 203,
  },
  {
    invoice_id: "6762558785356793",
    date: "2022-06-03",
    sales: 574,
  },
  {
    invoice_id: "3569259527141369",
    date: "2022-06-16",
    sales: 676,
  },
  {
    invoice_id: "4026605722032164",
    date: "2022-06-06",
    sales: 301,
  },
  {
    invoice_id: "6759097039372599131",
    date: "2022-06-01",
    sales: 537,
  },
  {
    invoice_id: "374622409294641",
    date: "2022-06-14",
    sales: 543,
  },
  {
    invoice_id: "3568014768847633",
    date: "2022-06-02",
    sales: 367,
  },
  {
    invoice_id: "3570535952336666",
    date: "2022-06-12",
    sales: 88,
  },
  {
    invoice_id: "3557077620664333",
    date: "2022-06-07",
    sales: 792,
  },
  {
    invoice_id: "3557443064363750",
    date: "2022-06-14",
    sales: 66,
  },
  {
    invoice_id: "3544321011138416",
    date: "2022-06-04",
    sales: 43,
  },
  {
    invoice_id: "4936306941347132",
    date: "2022-06-04",
    sales: 225,
  },
  {
    invoice_id: "490572803429778408",
    date: "2022-06-07",
    sales: 934,
  },
  {
    invoice_id: "5235782784062571",
    date: "2022-06-06",
    sales: 182,
  },
  {
    invoice_id: "5494750522058959",
    date: "2022-06-16",
    sales: 465,
  },
  {
    invoice_id: "4017959389982",
    date: "2022-06-11",
    sales: 792,
  },
  {
    invoice_id: "3533762327116088",
    date: "2022-06-14",
    sales: 629,
  },
  {
    invoice_id: "5018895178696396182",
    date: "2022-06-16",
    sales: 759,
  },
  {
    invoice_id: "5100170510754582",
    date: "2022-06-15",
    sales: 351,
  },
  {
    invoice_id: "3572515213013807",
    date: "2022-06-13",
    sales: 100,
  },
  {
    invoice_id: "67060959058460737",
    date: "2022-06-10",
    sales: 754,
  },
  {
    invoice_id: "4903371688499984528",
    date: "2022-06-14",
    sales: 347,
  },
  {
    invoice_id: "4405181131435456",
    date: "2022-06-15",
    sales: 404,
  },
  {
    invoice_id: "372301898239084",
    date: "2022-06-04",
    sales: 294,
  },
  {
    invoice_id: "3577782048209910",
    date: "2022-06-15",
    sales: 692,
  },
  {
    invoice_id: "3566843754878901",
    date: "2022-06-11",
    sales: 360,
  },
  {
    invoice_id: "4041371839457",
    date: "2022-06-13",
    sales: 730,
  },
  {
    invoice_id: "6331109544359911336",
    date: "2022-06-02",
    sales: 480,
  },
  {
    invoice_id: "5557010398168869",
    date: "2022-06-14",
    sales: 168,
  },
  {
    invoice_id: "67623893339484234",
    date: "2022-06-05",
    sales: 328,
  },
  {
    invoice_id: "4905075741583135483",
    date: "2022-06-13",
    sales: 868,
  },
  {
    invoice_id: "5048375305363474",
    date: "2022-06-04",
    sales: 43,
  },
  {
    invoice_id: "5602248257396842",
    date: "2022-06-10",
    sales: 384,
  },
  {
    invoice_id: "5100135651970297",
    date: "2022-06-07",
    sales: 713,
  },
  {
    invoice_id: "67713894000895527",
    date: "2022-06-16",
    sales: 209,
  },
  {
    invoice_id: "3570140013288814",
    date: "2022-06-15",
    sales: 510,
  },
  {
    invoice_id: "3563968683031752",
    date: "2022-06-02",
    sales: 621,
  },
  {
    invoice_id: "4917631391473267",
    date: "2022-06-10",
    sales: 952,
  },
  {
    invoice_id: "3528769966836485",
    date: "2022-06-11",
    sales: 790,
  },
  {
    invoice_id: "3552549259466797",
    date: "2022-06-14",
    sales: 871,
  },
  {
    invoice_id: "3569192853666537",
    date: "2022-06-02",
    sales: 673,
  },
  {
    invoice_id: "4913934864078314",
    date: "2022-06-16",
    sales: 652,
  },
  {
    invoice_id: "5018943471416756385",
    date: "2022-06-05",
    sales: 242,
  },
  {
    invoice_id: "3576480657954055",
    date: "2022-06-04",
    sales: 822,
  },
  {
    invoice_id: "060489794559933082",
    date: "2022-06-06",
    sales: 669,
  },
  {
    invoice_id: "3545460380399560",
    date: "2022-06-11",
    sales: 181,
  },
  {
    invoice_id: "4041595989773",
    date: "2022-06-01",
    sales: 218,
  },
  {
    invoice_id: "30144116875600",
    date: "2022-06-11",
    sales: 898,
  },
  {
    invoice_id: "3553752357801563",
    date: "2022-06-10",
    sales: 671,
  },
  {
    invoice_id: "6331100502007847",
    date: "2022-06-13",
    sales: 777,
  },
  {
    invoice_id: "3543170734608218",
    date: "2022-06-09",
    sales: 194,
  },
  {
    invoice_id: "5108759990722796",
    date: "2022-06-02",
    sales: 358,
  },
  {
    invoice_id: "3532323602744945",
    date: "2022-06-11",
    sales: 656,
  },
  {
    invoice_id: "5602211475909945",
    date: "2022-06-03",
    sales: 968,
  },
  {
    invoice_id: "3559544590000697",
    date: "2022-06-10",
    sales: 508,
  },
  {
    invoice_id: "6761994932783343",
    date: "2022-06-06",
    sales: 101,
  },
  {
    invoice_id: "5100140853290536",
    date: "2022-06-10",
    sales: 173,
  },
  {
    invoice_id: "5100173867422597",
    date: "2022-06-07",
    sales: 641,
  },
  {
    invoice_id: "3548550850790590",
    date: "2022-06-16",
    sales: 33,
  },
  {
    invoice_id: "3581607666275055",
    date: "2022-06-12",
    sales: 374,
  },
  {
    invoice_id: "3547843493402009",
    date: "2022-06-07",
    sales: 761,
  },
  {
    invoice_id: "5610117441769577419",
    date: "2022-06-07",
    sales: 539,
  },
  {
    invoice_id: "67623480640775771",
    date: "2022-06-13",
    sales: 438,
  },
  {
    invoice_id: "3541407191582748",
    date: "2022-06-10",
    sales: 21,
  },
  {
    invoice_id: "3541792993149402",
    date: "2022-06-01",
    sales: 688,
  },
  {
    invoice_id: "3575147340176047",
    date: "2022-06-10",
    sales: 463,
  },
  {
    invoice_id: "3532632698910461",
    date: "2022-06-17",
    sales: 717,
  },
  {
    invoice_id: "3543405559767115",
    date: "2022-06-17",
    sales: 792,
  },
  {
    invoice_id: "67638188328386745",
    date: "2022-06-01",
    sales: 360,
  },
  {
    invoice_id: "633110345653946149",
    date: "2022-06-17",
    sales: 178,
  },
  {
    invoice_id: "5602218735372038",
    date: "2022-06-17",
    sales: 893,
  },
];
